import _ from 'lodash';
import {error} from '.';
import {geoserverBase} from '../config/environment';
import {createDeferred} from '../utils/deferred';
import {assert200} from '../utils/fetch_utils';
import {parseWcs} from '../utils/wind_utils';
import * as ActionTypes from './actionTypes';

const _constructRequestString = (layer, time) => {
  const base = layer.base || geoserverBase;
  const baseRequestParameters = 'VERSION=2.0.1&REQUEST=GetCoverage&FORMAT=text/plain';
  const formatted_time = new Date(time).toISOString();

  return base
         + layer.wcs_source
         + baseRequestParameters
         + '&COVERAGEID=' + layer.params.layers
         + '&SUBSET=TIME("' + formatted_time + '")'
         + '&scaleFactor=0.1';
};

const _parseWcs = (text, time) => {
  return Promise.resolve(parseWcs(text, time));
};

const _populateWcsDataAsync = (layer, time, action_type, map_bounds, map_zoom, deferred) => {
  return dispatch => {
    if (!layer.wcs_source) {
      dispatch(error('Call to get WCS data for layer without WCS Source: ' + layer.prefix));
      return;
    }

    fetch(_constructRequestString(layer, time))
    .then(response => {
      if (response.status === 404) {
        // Skip processing for 404 responses without reporting an error
        return Promise.reject({ skipError: true });
      }
      return assert200(response);
    })
    .then(response => response.text())
    .then(text => _parseWcs(text, time))
    .then(data => dispatch(_populateWcsData(action_type, data, time, map_bounds, map_zoom)))
    .then(deferred.resolve)
    .catch(e => {
      if (e.skipError) {
        deferred.resolve();
        return;
      }

      const msg = 'Call to get WCS data failed: ' + e.message;
      dispatch(error(msg));
      deferred.reject(msg);
    });
  };
};

const _populateWcsData = (action_type, data, time, map_bounds, map_zoom) => {
  return {
    type: action_type, data, time, map_bounds, map_zoom
  };
};

export const populateWindMagnitudeDataPromise = (map_bounds, map_zoom, time, deferred = createDeferred()) => {
  return (dispatch, getState) => {
    if (getState().wind_data.magnitude_data[time]) {
      deferred.resolve();
    } else {
      const indicator = _.keyBy(getState().indicators.indicators, 'prefix')['HP_WindMag_SFC'];
      dispatch(_populateWcsDataAsync(indicator, time, 'POPULATE_MAGNITUDE_DATA', map_bounds, map_zoom, deferred));
    }
    return deferred.promise;
  };
};

export const populateWindDirectionDataPromise = (map_bounds, map_zoom, time, deferred = createDeferred()) => {
  return (dispatch, getState) => {
    if (getState().wind_data.direction_data[time]) {
      deferred.resolve();
    } else {
      const indicator = _.keyBy(getState().indicators.indicators, 'prefix')['HP_Wind_Dir_SFC'];
      dispatch(_populateWcsDataAsync(indicator, time, 'POPULATE_DIRECTION_DATA', map_bounds, map_zoom, deferred));
    }
    return deferred.promise;
  };
};

export const setWindVelocityData = (time) => {
  return {
    type: ActionTypes.SET_VELOCITY_DATA, time
  };
};

export const setWindBarbData = (time) => {
  return {
    type: ActionTypes.SET_BARB_DATA, time
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_wind_data.js